import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { defineComponent as _defineComponent } from 'vue';
import { SCheckbox } from '@strana-artw/ui-kit';
import { useVuelidate } from '@vuelidate/core';
import { sameAs } from '@vuelidate/validators';
import { defineComponent, reactive, set, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericAcceptPolicy',
  props: {
    policies: {
      type: Array,
      required: true
    },
    target: {
      type: String,
      default: '_blank'
    }
  },
  emits: ["change"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    defineComponent({
      name: 'GenericAcceptPolicy'
    });
    function getLink(slug) {
      return "/legal-documents/".concat(slug);
    }
    var formState = reactive({});
    var _iterator = _createForOfIteratorHelper(props.policies),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var items = _step.value;
        set(formState, items.documentSlug, false);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var state = reactive({
      form: formState
    });
    var formRules = reactive({});
    var _iterator2 = _createForOfIteratorHelper(props.policies),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _items = _step2.value;
        set(formRules, _items.documentSlug, {
          sameAs: sameAs(true)
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var rules = {
      form: formRules
    };
    var v$ = useVuelidate(rules, state);
    var previousRes = '';
    watch(function () {
      return v$.value.form.$model;
    }, function (newValue) {
      var currentRes = Object.values(newValue).map(Number).join('');
      if (currentRes !== previousRes) {
        emit('change', _objectSpread({}, newValue));
      }
      previousRes = currentRes;
    }, {
      deep: true
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      getLink: getLink,
      formState: formState,
      state: state,
      formRules: formRules,
      rules: rules,
      v$: v$,
      previousRes: previousRes,
      SCheckbox: SCheckbox
    };
  }
});